import React from 'react';


export default function withImageLoad(Component, loaderFunc) {
    return class WrappedClass extends React.Component {
        constructor(props){
            super(props)
        }
        render() {
            const props = {
                ...this.props,
                imageLoader: loaderFunc
            }
            return (
                <Component {...props}/>
            )
        }
    }
}

